import React, { Component } from 'react'

// Styles
import './index.scss'

// Constants
import { POLYCOMS } from './constants'

class Certifications extends Component {
  render = () => {
    return (
      <div className="certifications-parent">
        <div className="page-banner bg-page-banner vh-center">
          <div className="banner-content">
            <h2>Certifications & Licenses</h2>
          </div>
        </div>

        <div className="container">
          <div className="page-section">
            <p>With wide-ranging expertise and experience, EIDIM offers a comprehensive audio visual service making us the AV partner of choice for many organisations. We can lead and manage large and complex audio visual projects, but also tailor effective solutions for smaller-scale requirements.</p>
          </div>
        </div>

        <div className="container">
          <h2>Licenses</h2>
          <div className="license-media">
            <img src="https://eidim-media2.s3-us-west-1.amazonaws.com/images/company/certifications/contractors-license.jpg" alt="Contractors License" />
          </div>
        </div>

        <div className="container">
          <h2>Certifications</h2>
          <div className="certifications-logo">
            <ul>
              <li>
                <img src="https://eidim-media2.s3-us-west-1.amazonaws.com/images/company/certifications/hubzone-logo.jpg" alt="Hubzone" />
              </li>

              <li>
                <img src="https://eidim-media2.s3-us-west-1.amazonaws.com/images/company/certifications/cmas-logo.jpg" alt="CMAS" />
              </li>

              <li>
                <img src="https://eidim-media2.s3-us-west-1.amazonaws.com/images/company/certifications/apex-logo.jpg" alt="APEX" />
              </li>
            </ul>
          </div>
        </div>

        <div className="container other-certifications">
          <h2>Other Certifications</h2>
          <table>
            <tbody>
              <tr>
                <td>Audinate</td>
                <td>Dante 1, 2, 3</td>
                <td>Digital Audio Network Through Ethernet</td>
              </tr>

              <tr>
                <td rowSpan="4">Avixa</td>
                <td>CTS</td>
                <td>Certified Technology Specialist</td>
              </tr>

              <tr>
                <td>CTS-D</td>
                <td>Certified Technology Specialist Design</td>
              </tr>

              <tr>
                <td>CTS-I</td>
                <td>Certified Technology Specialist Installation</td>
              </tr>

              <tr>
                <td>Apex</td>
                <td>AV Provider of Excellence</td>
              </tr>

              <tr>
                <td>B2G Institute	</td>
                <td></td>
                <td>Business Government Mastery</td>
              </tr>

              <tr rowSpan="3">
                <td>Barco</td>
                <td></td>
                <td>Certified Specialist</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Wide Screen Certification</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Media and Entertainment Technical</td>
              </tr>

              <tr rowSpan="3">
                <td>Biamp</td>
                <td></td>
                <td>Audia</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Vocia</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>TesiraFORTÉ & TESIRA SERVER</td>
              </tr>

              <tr>
                <td>BSS</td>
                <td></td>
                <td>Audio Programming</td>
              </tr>

              <tr rowSpan="3">
                <td>Chief</td>
                <td></td>
                <td>Install Track</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Automated Classroom Install</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Mounting Solutions</td>
              </tr>

              <tr rowSpan="3">
                <td>Cisco</td>
                <td></td>
                <td>Telepresence</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Tandenberg</td>
              </tr>

              <tr>
                <td></td>
                <td>ATP</td>
                <td>Authorized Technology Provider</td>
              </tr>

              <tr rowSpan="3">
                <td>ClearOne</td>
                <td></td>
                <td>Pro Audio Technical Specialist</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Professional Conferencing Products</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Certified Specialist</td>
              </tr>

              <tr>
                <td>Commscope</td>
                <td>SP3000</td>
                <td>Structured Cabling</td>
              </tr>

              <tr rowSpan="9">
                <td>Crestron</td>
                <td>CAT</td>
                <td>Certified Audio Technician</td>
              </tr>

              <tr>
                <td></td>
                <td>DM NVX</td>
                <td>DM NVX Certification</td>
              </tr>

              <tr>
                <td></td>
                <td>DMC-D-4K</td>
                <td>Digital Media Certified- 4k- Design</td>
              </tr>

              <tr>
                <td></td>
                <td>DMC-E-4K</td>
                <td>Digital Media Certified- 4k- Engineer</td>
              </tr>

              <tr>
                <td></td>
                <td>DMC-T-4K</td>
                <td>Digital Media Certified- 4k- Technician</td>
              </tr>

              <tr>
                <td></td>
                <td>CTI-SG</td>
                <td>Smart Graphics</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Crestron Programming</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Lighting Control</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Commercial System Design</td>
              </tr>

              <tr rowSpan="6">
                <td>Extron</td>
                <td>EAVA</td>
                <td>Extron AV Associates</td>
              </tr>

              <tr>
                <td></td>
                <td>SDI & HD-SDI</td>
                <td>Design</td>
              </tr>

              <tr>
                <td></td>
                <td>XTP, XTP-E</td>
                <td>Certified XTP Systems and Engineer</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Emerging Technologies 4k</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Control Specialist</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Videowall System Design</td>
              </tr>

              <tr>
                <td>HDBaseT</td>
                <td></td>
                <td>Authorized HDBaseT Alliance Trainer</td>
              </tr>

              <tr>
                <td>L-Acoustics</td>
                <td></td>
                <td>Sound Vision</td>
              </tr>

              <tr>
                <td>OSHA</td>
                <td></td>
                <td>30 HR Construction Safety Training</td>
              </tr>

              <tr rowSpan="2">
                <td>Tripp•Lite</td>
                <td>KVM</td>
                <td>KVM Switches</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Digital Signage Solutions</td>
              </tr>

              <tr rowSpan="2">
                <td>Shure</td>
                <td></td>
                <td>Integrated System Certification</td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td>Microflex Advance Training</td>
              </tr>

              <tr rowSpan="7">
                <td>Harman</td>
                <td>CC101</td>
                <td>IP Video Essentials</td>

              </tr>

              <tr>
                <td></td>
                <td>CC101</td>
                <td>Audio Essentials</td>
              </tr>

              <tr>
                <td></td>
                <td>CC102</td>
                <td>Cabling Essentials</td>
              </tr>

              <tr>
                <td></td>
                <td>CC103</td>
                <td>Control Essentials</td>
              </tr>

              <tr>
                <td></td>
                <td>CC104</td>
                <td>Networking Essentials</td>
              </tr>

              <tr>
                <td></td>
                <td>CC105</td>
                <td>PC Essentials</td>
              </tr>

              <tr>
                <td></td>
                <td>CC106</td>
                <td>Video Essentials</td>
              </tr>

              <tr>
                <td>QSC</td>
                <td>Q-SYS</td>
                <td>Level 1 QSYS Certified</td>
              </tr>

              <tr rowSpan="3">
                <td>Planar	G3 LCD</td>
                <td></td>
                <td>Videowall System Installer</td>
              </tr>

              <tr>
                <td></td>
                <td>Leyard TVF</td>
                <td>LED Video Wall Certified</td>
              </tr>

              <tr>
                <td></td>
                <td>Clarity	Matrix</td>
                <td>Certified Installer</td>
              </tr>

              <tr>
                <td>Solstice</td>
                <td></td>
                <td></td>
              </tr>

              <tr>
                <td>Yamaha</td>
                <td></td>
                <td>Commercial Audio PM5D Operational</td>
              </tr>

              <tr rowSpan="11">
                <td>{POLYCOMS.title}</td>
                <td>{POLYCOMS.type}</td>
                <td>{POLYCOMS.desc}</td>
              </tr>

              {
                POLYCOMS.detail.map((item, i) => {
                  const { type, desc } = item
                  return (
                    <tr key={`type-${i}`}>
                      <td></td>
                      <td>{type}</td>
                      <td>{desc}</td>
                    </tr>
                  )
                })
              }



            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default Certifications